import BigNumber from 'bignumber.js';

// round(max(minSubscription, min(input, balance, maxSubscription))/lotSize)*lotSize

interface GetRoundedInputAmountParams {
  amount: number;
  maxAmount: number;
  minAmount: number;
  balance?: number;
  stepSize?: number | null;
}

export const checkBalance = ({ amount, balance }: { amount: number; balance: number }) => {
  const amountBN = new BigNumber(amount);
  const balanceBN = new BigNumber(balance);
  return amountBN.isGreaterThan(balanceBN);
};

export const getRoundedInputAmount = ({ amount, balance, minAmount, maxAmount, stepSize }: GetRoundedInputAmountParams) => {
  if (balance === undefined) {
    return amount;
  }

  const stepSizeBN = new BigNumber(stepSize || 0);
  const amountBN = new BigNumber(amount);
  const balanceBN = new BigNumber(balance);
  const minAmountBN = new BigNumber(minAmount);
  const maxAmountBN = new BigNumber(maxAmount);

  let inputAmountBN = amountBN;
  const maxAmountToUse = balanceBN.gt(maxAmountBN) ? maxAmountBN : balanceBN;

  if (amountBN.lt(minAmountBN)) {
    inputAmountBN = minAmountBN;
  }
  if (amountBN.gt(maxAmountToUse)) {
    inputAmountBN = maxAmountToUse;
  } else if (amountBN.gt(balanceBN)) {
    inputAmountBN = balanceBN;
  }

  if (stepSize) {
    const roundedInputAmount = inputAmountBN.div(stepSizeBN).integerValue(BigNumber.ROUND_DOWN).multipliedBy(stepSizeBN);
    return roundedInputAmount.toNumber();
  }

  return inputAmountBN.toNumber();
};
